<template>
  <div class="p-4">
    <h2 class="text-center">关于GPS天线</h2>
    <p>部分高配车型(详见下表)自带高德导航，由于自带的导航是一个独立的盒子，中控无法使用其自带的网络和GPS信号，导致车机后安装的地图无法定位，
车友可以通过加装GPS天线解决此问题。GPS天线型号为：gt5-1s，淘宝上可以购买。具体安装方法请自行网上搜索或咨询淘宝卖家（注：优化后自带的原厂导航可以正常使用，互相独立，没有影响）</p>
    <table class="table table-bordered">
      <thead class="thead-light">
        <tr>
          <th>车型</th>
          <th>无GPS天线，需要加装</th>
          <th>有GPS天线，不用加装</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>思域</td>
          <td>2016～2018: 尊贵、尊耀需要加装<br />2019~至今：劲擎、燃擎需要加装</td>
          <td>除左侧车型</td>
        </tr>
        <tr>
          <td>皓影</td>
          <td>带原厂导航且屏幕左侧有MAP按键的需要加装</td>
          <td>不带原厂导航，屏幕左侧没有MAP按键的车型</td>
        </tr>
        <tr>
          <td>CRV</td>
          <td>全部车型都需要加装</td>
          <td></td>
        </tr>
        <tr>
          <td>冠道</td>
          <td>带原厂导航且屏幕左侧有MAP按键的需要加装</td>
          <td>不带原厂导航，屏幕左侧没有MAP按键的车型</td>
        </tr>
        <tr>
          <td>URV</td>
          <td>带原厂导航且屏幕左侧有MAP按键的需要加装</td>
          <td>不带原厂导航，屏幕左侧没有MAP按键的车型</td>
        </tr>
        <tr>
          <td>讴歌CDX</td>
          <td></td>
          <td>全部车型不用加装</td>
        </tr>
      </tbody>
    </table>
    <span>注：新版本的中控大师软件可以自行检测车机是否有GPS天线，检测方法：把车开到空旷地带，车里打开中控大师，点「更多功能」，再点「其他」，然后点「GPS天线检测」</span>
  </div>
</template>

<script>
export default {
  name: "Gps",
  components: {},
  props: [],
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      table: {
        data: [],
      },
    };
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {},
  watch: {},
  filters: {},
};
</script>
